import { CommApiInstance } from "Utils/CommApiInstance";

const QnaTmpltCtxtApi = async (
    gameSvcCd:string,
    ctntCtgrCd:string,
) => {
    
    return await CommApiInstance.post(`/comm/${gameSvcCd}/qna/${ctntCtgrCd}`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
    
}
export default QnaTmpltCtxtApi;